import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import smoothScroll from '../../utils/smoothScroll';
import './styles.css';

const ToggleSection = ({
  moreText,
  lessText,
  children,
  parentSelector,
  onToggle,
}) => {
  const [show, setShow] = useState();

  const onClick = useCallback(() => {
    if (onToggle) onToggle(!show);
    setShow(!show);
  }, [show]);

  return (
    <div className="ToggleSection__root">
      <div
        className={classNames('ToggleSection__content', {
          'ToggleSection__content--show': show,
        })}
      >
        {children}
      </div>
      <button
        className="ToggleSection__button"
        onClick={() => {
          if (show && parentSelector)
            smoothScroll(document.querySelector(parentSelector), 66);
          onClick();
        }}
      >
        {show ? lessText : moreText}
        <i
          className={
            show ? 'icon-generalcaretupmedium' : 'icon-generalcaretdownmedium'
          }
        />
      </button>
    </div>
  );
};

export default ToggleSection;
